import { useState, useEffect } from 'react';
import { HttpClient } from '../../../Domain/Utils/ApiUtilies/Fetch/Fetch';
import { API_ABOUT_COURSE } from '../../../Domain/Redux/Paths';
import { getParamFromUrl } from '../../../Domain/Utils/UrlUtilies/UrlUtilies';
import { COMPONENTS } from '../../../Domain/Settings/Constants/ComponentsParameter/ComponentsParameter';

export const useWhyTakeCourse = ({ language }) => {
  const [about, setAbout] = useState([]);
  const course = getParamFromUrl('course');

  useEffect(() => {
    if (!language) return;
    HttpClient.GET(API_ABOUT_COURSE, {
      course,
      component: COMPONENTS.ABOUT,
      language
    }).then((response) => {
      if (!Array.isArray(response.content)) return;
      setAbout(response.content);
    });
  }, [language]);

  return { about };
};